module.exports = __webpack_public_path__ + "static/media/aboutus-irishowned-1-mobile.1a7b3574.jpg";